import React from 'react';
import SectionCard from '../controls/SectionCard';
import Button from '../controls/Button';
import styles from './TextEditSection.module.css';

const TextEditSection = ({ model, selectedIds, onStartTextEdit, editingTextId }) => {
  const isLocked = !model.canEdit;
  const canEdit = selectedIds.length === 1 && model.selectionType === 'text' && !isLocked;
  const selectedId = selectedIds[0];

  return (
    <SectionCard title="Text">
      <div className={styles.row}>
        <Button
          onClick={() => onStartTextEdit(selectedId)}
          disabled={!canEdit || Boolean(editingTextId)}
          variant="primary"
        >
          Edit text
        </Button>
        {!canEdit && !isLocked && (
          <span className={styles.helper}>
            Select a single text box to edit.
          </span>
        )}
        {isLocked && (
          <span className={styles.helper}>
            Unlock the element to edit text.
          </span>
        )}
      </div>
    </SectionCard>
  );
};

export default TextEditSection;
